import "../../../../ReactComponents/Components/PartnerDetails/PartnerDetails";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import PartnerDetailsReactWrapperController from "./PartnerDetailsReactWrapperController";

export default class PartnerDetailsReactWrapper implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public template: string;

    constructor() {
        this.bindings = {
            partnerId: "<",
        };
        this.controller = PartnerDetailsReactWrapperController;
        this.template = "<PartnerDetails></PartnerDetails>";
    }
}

module("mmManagePortal").component("irPartnerDetailsReactWrapper", new PartnerDetailsReactWrapper());
